define("checkout/components/seamless-checkout/non-admin-modal", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "shared/utils/plans-data/feature-upgrade", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _featureUpgrade, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"shared/utils/plans-data/feature-upgrade",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal @closable={{true}} @close={{this.close}} @focusTrap={{true}} as |modal|>
    <modal.card @portrait={{true}}>
      <modal.card-header class="u--p__b__sm">
        <p class="o--modalHeader__title">{{this.text.title}} </p>
      </modal.card-header>
      <modal.card-body class="u--p__t__0">
        <section>
          <div class="u--m__t__0">
            {{this.text.body}}
            <Shared::Link
              @href="https://help.later.com/hc/articles/360061664373"
              @openInNewTab={{true}}
              @text={{t "shared_phrases.learn_more_lower_case"}}
            />
          </div>
        </section>
      </modal.card-body>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "nzZivQ3G",
    "block": "[[[8,[39,0],null,[[\"@closable\",\"@close\",\"@focusTrap\"],[true,[30,0,[\"close\"]],true]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__b__sm\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,[30,0,[\"text\",\"title\"]]],[1,\" \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,\"section\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"u--m__t__0\"],[12],[1,\"\\n          \"],[1,[30,0,[\"text\",\"body\"]]],[1,\"\\n          \"],[8,[39,1],null,[[\"@href\",\"@openInNewTab\",\"@text\"],[\"https://help.later.com/hc/articles/360061664373\",true,[28,[37,2],[\"shared_phrases.learn_more_lower_case\"],null]]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\"],false,[\"shared/modal\",\"shared/link\",\"t\"]]",
    "moduleName": "checkout/components/seamless-checkout/non-admin-modal.hbs",
    "isStrictMode": false
  });
  let NonAdminModalComponent = _exports.default = (_class = class NonAdminModalComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
    }
    get isLegacyAccount() {
      return this.auth.currentAccount.isOnLegacyPlan && !this.auth.currentAccount.pricingV1Free;
    }
    get selectedFeature() {
      return this.seamlessCheckoutManager.selectedFeature ?? '';
    }
    get featureMapList() {
      return this.seamlessCheckoutManager.featureMapList;
    }
    get text() {
      const featureName = (0, _featureUpgrade.getFeatureNameFromList)(this.intl, this.selectedFeature);
      const upgradeName = (0, _featureUpgrade.getUpgradeNameFromActions)(this.intl, this.selectedFeature);

      // Note: For feature upgrade actions such as ai credits. a legacy plan might not have the base feature,
      // so we need to make sure the modal says 'get feature' instead of 'get more feature'
      if (this.isLegacyAccount || featureName) {
        return {
          title: this.intl.t('plans.non_admin.upgrade_plan.title'),
          body: this.intl.t('plans.non_admin.upgrade_plan.body', {
            featureName: featureName ?? this.intl.t('shared_phrases.more_features'),
            ownerEmail: this.ownerEmail
          })
        };
      }
      if (upgradeName) {
        return {
          title: this.intl.t('plans.non_admin.update_plan.title', {
            featureName: upgradeName
          }),
          body: this.intl.t('plans.non_admin.update_plan.body', {
            featureName: upgradeName,
            ownerEmail: this.ownerEmail
          })
        };
      }
      return {
        title: this.intl.t('plans.non_admin.upgrade_plan.title'),
        body: this.intl.t('plans.non_admin.upgrade_plan.body', {
          featureName: this.intl.t('shared_phrases.more_features'),
          ownerEmail: this.ownerEmail
        })
      };
    }
    get ownerEmail() {
      return this.auth.currentAccount.owner.get('email') ?? '';
    }
    close() {
      this.seamlessCheckoutManager.closeModal();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "close", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, NonAdminModalComponent);
});